import { useEffect } from "react";
import { Loading } from "@components/LoadMore/LoadMore";
import useSendDataToGTM from "@features/analytics/hooks/useSendDataToGTM";
import { TrackingObject } from "@features/analytics/utils/types";
import { useMyBtKeywords } from "@features/mybt/hooks/useMyBtKeywords";
import { useIsFirstMount } from "@hooks/useIsFirstMount";
import { useGetMyBTArticleList } from "@routes/MyAccount/hooks/useGetMyBTArticleList";

import MyAccountMyBTPageEmptyState from "./MyAccountMyBTPageEmptyState";
import MyAccountMyBTPageList from "./MyAccountMyBTPageList";

export default function MyAccountMyBtPage(): React.ReactElement {
  const sendDataToGTM = useSendDataToGTM();
  const isFirstMount = useIsFirstMount();

  const { tags } = useMyBtKeywords();

  const { myBTArticleList, isLoading, ref } = useGetMyBTArticleList({
    tags,
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!isFirstMount) return;

    const userKeywords = tags.map(({ name }) => name).join("|");

    const gaObject: TrackingObject = {
      event: "custom_event",
      eventCategory: "mybt",
      eventAction: "visible",
      eventLabel: window.location.href,
    };

    if (userKeywords) {
      gaObject["user_keyword"] = userKeywords;
    }

    sendDataToGTM(gaObject);
  }, [tags, sendDataToGTM, isFirstMount]);

  return (
    <div data-testid="my-account-my-bt-page-component" className="w-full">
      {myBTArticleList.length > 0 ? (
        <MyAccountMyBTPageList
          tagWithArticleList={myBTArticleList}
          loadMoreRef={ref}
        />
      ) : (
        <MyAccountMyBTPageEmptyState />
      )}

      <Loading isLoading={isLoading} />
    </div>
  );
}
